"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var _1 = __importDefault(require("./"));
exports.useEvent = function (name, callback, arrayOfState) {
    var listenerRef = react_1.useRef('');
    react_1.useEffect(function () {
        var eventId = _1.default.on(name, callback);
        if (typeof eventId !== 'string')
            return;
        listenerRef.current = eventId;
        return function () {
            _1.default.rm(listenerRef.current);
        };
    }, arrayOfState);
};
exports.useGlobalState = function (initialValue, uniqueId) {
    var valueRef = react_1.useRef(initialValue);
    var _a = react_1.useState(valueRef.current), value = _a[0], setValue = _a[1];
    react_1.useEffect(function () {
        _1.default.emit('GLOBAL_STATE_' + uniqueId, value);
    }, [value]);
    exports.useEvent('GLOBAL_STATE_' + uniqueId, function (newValue) {
        if (value !== newValue) {
            setValue(newValue);
            valueRef.current = newValue;
        }
    }, [value]);
    return [value, setValue];
};
exports.makePersistState = function (_a) {
    var getItem = _a.getItem, setItem = _a.setItem;
    return function (initialValue, uniqueId, type) {
        var valueRef = react_1.useRef(initialValue);
        var _a = exports.useGlobalState(false, uniqueId + "-is-ready"), isReady = _a[0], setIsReady = _a[1];
        var _b = exports.useGlobalState(valueRef.current, uniqueId), value = _b[0], setValue = _b[1];
        var getInitialData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var localValue;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, getItem(uniqueId, type)];
                    case 1:
                        localValue = _a.sent();
                        if (localValue !== null) {
                            setValue(localValue);
                            setIsReady(true);
                            valueRef.current = localValue;
                        }
                        return [2];
                }
            });
        }); };
        react_1.useEffect(function () {
            if (isReady)
                return;
            getInitialData();
        }, []);
        react_1.useEffect(function () {
            setItem(uniqueId, value, type);
        }, [value]);
        return [value, setValue, isReady];
    };
};
exports.default = _1.default;
//# sourceMappingURL=react.js.map